import sim1 from '../assets/jbd/EvoTrasMix/MixSubband15.mp4';
import sim2 from '../assets/jbd/EvoTrasMix/MixSubband40.mp4';
import sim3 from '../assets/jbd/EvoTrasMix/MixSubband65.mp4';
import sim4 from '../assets/jbd/EvoTrasMix/MixSubband100.mp4';

import sim5 from '../assets/jbd/EvoTrasNoMix/EvoTrasNoMix15.mp4';
import sim6 from '../assets/jbd/EvoTrasNoMix/EvoTrasNoMix40.mp4';
import sim7 from '../assets/jbd/EvoTrasNoMix/EvoTrasNoMix65.mp4';
import sim8 from '../assets/jbd/EvoTrasNoMix/EvoTrasNoMix100.mp4';

import sim9 from '../assets/jbd/EvoTuneMix/MixSubbandTun5.mp4';
import sim10 from '../assets/jbd/EvoTuneMix/MixSubbandTun15.mp4';
import sim11 from '../assets/jbd/EvoTuneMix/MixSubbandTun35.mp4';
import sim12 from '../assets/jbd/EvoTuneMix/MixSubbandTun100.mp4';

import sim13 from '../assets/jbd/EvoTuneNoMix/EvoTuneNoMix5.mp4';
import sim14 from '../assets/jbd/EvoTuneNoMix/EvoTuneNoMix15.mp4';
import sim15 from '../assets/jbd/EvoTuneNoMix/EvoTuneNoMix25.mp4';
import sim16 from '../assets/jbd/EvoTuneNoMix/EvoTuneNoMix35.mp4';
import {AnimationData} from "./animations";

export const EvoTrasMix: AnimationData[] = [
    { title: "Fig 1.1: Schematic", description: "Simulation 1", videoUrl: sim1 },
    { title: "Fig 1.2: Schematic", description: "Simulation 1", videoUrl: sim2 },
    { title: "Fig 1.3: Schematic", description: "Simulation 1", videoUrl: sim3 },
    { title: "Fig 1.4: Schematic", description: "Simulation 1", videoUrl: sim4 },
];

export const EvoTrasNoMix = [
    { title: "Fig 2.1: Schematic", description: "Simulation 2", videoUrl: sim5 },
    { title: "Fig 2.2: Schematic", description: "Simulation 2", videoUrl: sim6 },
    { title: "Fig 2.3: Schematic", description: "Simulation 2", videoUrl: sim7 },
    { title: "Fig 2.4: Schematic", description: "Simulation 2", videoUrl: sim8 },
];

export const EvoTuneMix = [
    { title: "Fig 3.1: Schematic", description: "Simulation 3", videoUrl: sim9 },
    { title: "Fig 3.2: Schematic", description: "Simulation 3", videoUrl: sim10 },
    { title: "Fig 3.3: Schematic", description: "Simulation 3", videoUrl: sim11 },
    { title: "Fig 3.4: Schematic", description: "Simulation 3", videoUrl: sim12 },
];

export const EvoTuneNoMix = [
    { title: "Fig 4.1: Schematic", description: "Simulation 4", videoUrl: sim13 },
    { title: "Fig 4.2: Schematic", description: "Simulation 4", videoUrl: sim14 },
    { title: "Fig 4.3: Schematic", description: "Simulation 4", videoUrl: sim15 },
    { title: "Fig 4.4: Schematic", description: "Simulation 4", videoUrl: sim16 },
];